import * as React from 'react';
import { LibraryCard, CardType, CardPropertyType } from '../../../../../types/LibraryCard';
import Card from '../../../../Feed/Card/Card';
import './MobileBookHeader.css';
import { getDatePeriod } from '../../../../../utils';
import Arrow from '@material-ui/icons/ArrowDropDown';
import { CallbacksContext } from '../../../BookCalendar';
import EditBookCard from '../../../../EditBookCard/EditBookCard';
import Drawer from '@material-ui/core/Drawer';
import MobileBookPeekCategory from './MobileBookPeekCategory/MobileBookPeekCategory';

interface Props {
	card: LibraryCard;
}

const MobileBookHeader: React.FC<Props> = ({ card }) => {
	const [editBookOpen, setEditBookOpen] = React.useState(false);

	const showEditBookOpen = () => setEditBookOpen(true);
	const hideEditBookOpen = () => {
		setEditBookOpen(false);
	}

	const callbacks = React.useContext(CallbacksContext);

	return (
		<div className="mobile-book-card-book__wrapper">
			<div className="mobile-book-card-book">
				<Card
					toBookPage={true}
					book={{
						...card.book,
						card: {
							id: card.eId,
							type: card.cardType,
						},
					}}
					hiddenCheckIcon={true}
				/>
			</div>

			{card.book.collection?.id === 20 && <MobileBookPeekCategory book={card.book}/>}

			{card.cardType === CardType.AlreadyRead && (
				<div className="mobile-book-card-book__controls">
					<div
						className="mobile-book-card-book__status"
						onClick={showEditBookOpen}
					>
						Запланировать
						{card.cardType !== CardType.AlreadyRead &&
							card.properties[CardPropertyType.DateBegin] &&
							` ${getDatePeriod(
								card.properties[CardPropertyType.DateBegin] as any,
								card.properties[CardPropertyType.DateFinish] as any
							)}`}
						<Arrow />
					</div>
				</div>
			)}

			<Drawer open={editBookOpen} anchor="bottom" onClose={hideEditBookOpen}>
				<EditBookCard
					book={card.book}
					onSaved={hideEditBookOpen}
					libraryCard={card}
					saveCard={callbacks.addCard}
					saveProperties={callbacks.saveCardProperties}
					onClose={hideEditBookOpen}
					hideBookCard={true}
				/>
			</Drawer>
		</div>
	);
};

export default MobileBookHeader;
